import * as React from "react";
export function SvgSchemaViewerGroupDiscrete(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M15 2.4c-1.8-.9-4.1-.2-5 1.6l-3 6c-.7 1.4-.1 3 1.2 3.7s3 .1 3.7-1.2l2.4-4.7c.4-.9.1-1.9-.8-2.4-.9-.4-1.9-.1-2.4.8l-2 3.8.9.5 2-3.9c.2-.4.6-.5 1-.3s.5.6.3 1L10.9 12c-.4.9-1.5 1.2-2.4.8s-1.2-1.5-.8-2.4l3-6c.7-1.4 2.3-1.9 3.7-1.2s1.9 2.3 1.2 3.7l-2.5 4.9.9.5 2.5-4.9c1-1.8.3-4.1-1.5-5z"
        fill="#367e9c"
      />
    </svg>
  );
}
